import { renameKeys, transformKeysToSnakeCase } from 'helpers/core';
import { RESERVATIONS_PER_PAGE, SCHEDULES_PER_PAGE } from './Stats.constants';

const getUnselectedItems = (selected, possible) => {
  const selectedSet = new Set(selected);
  return possible.filter(item => !selectedSet.has(item));
};

const getUnselectedClassIds = (selectedClasses, possibleClasses, classNameToClassIdsMap = {}) =>
  // TODO: use slick ES2019 flatmap when node supports it and it will work without failing all the mocha tests
  // getUnselectedItems(selectedClasses, possibleClasses).flatMap(className => classNameToClassIdsMap[className] || []);
  getUnselectedItems(selectedClasses, possibleClasses).reduce((memo, className) => {
    memo.push(...(classNameToClassIdsMap[className] || []));
    return memo;
  }, []);

const reportsQueryKeyMap = {
  selectedVenues: 'venueIds',
  page: 'pageNumber',
};

const constructParams = (isTableQuery, isReservationsPage, filters, classNameToClassIdsMap) => {
  const {
    startDate,
    endDate,
    selectedVenues,
    page,
    possibleClasses,
    possibleStartTimes,
    possibleStatuses,
    selectedClasses,
    selectedStartTimes,
    selectedStatuses,
    sortDirection,
    sortField,
  } = filters;
  const sortDirectionForSchedules = sortDirection === 'dsc' ? 'desc' : 'asc';

  // applies to all queries
  const params = {
    startDate,
    endDate,
    selectedVenues,
  };

  if (selectedClasses.length !== possibleClasses.length) {
    params.excludedClassIds = getUnselectedClassIds(selectedClasses, possibleClasses, classNameToClassIdsMap);
  }
  if (selectedStartTimes.length !== possibleStartTimes.length) {
    params.excludedStartTimes = getUnselectedItems(selectedStartTimes, possibleStartTimes);
  }

  // adds filter that exists on reservations, but not schedules
  if (isReservationsPage && selectedStatuses.length !== possibleStatuses.length) {
    params.excludedStatuses = getUnselectedItems(selectedStatuses, possibleStatuses);
  }

  // adds the fields that the table needs, but the csv does not
  if (isTableQuery) {
    params.page = page;
    params.pageSize = isReservationsPage ? RESERVATIONS_PER_PAGE : SCHEDULES_PER_PAGE;
    params.sort = isReservationsPage
      ? [`${sortField}:${sortDirection}`]
      : [`class_datetime:${sortDirectionForSchedules}`, 'venue:asc', 'class:asc'];
  }

  return transformKeysToSnakeCase(renameKeys(params, reportsQueryKeyMap));
};

export const constructParamsReservationsTable = constructParams.bind(null, true, true);

export const constructParamsSchedulesTable = constructParams.bind(null, true, false);

export const constructParamsCsv = constructParams.bind(null, false);
